module.exports = __webpack_public_path__ + "static/media/figure5.be724efd.jpg";